module.exports = __webpack_public_path__ + "img/sticker-cat-questions.bd505847.png";